import { useEffect, useState } from "react";
import { useForm, Controller } from 'react-hook-form'
import DatePicker from "react-multi-date-picker";
import moment from 'moment/moment';

import Modal from '../Modal';
import { createProject, getProject, updateProject } from "../../api/project.api";
import { projectTemplateMarkdown, projectTemplateOptions } from "../../services/stringServices";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { AuthData } from "../../pages/Authorization/AuthWrapper";

export function ProjectModal({projectId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[project, setProject] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();
    const {refreshSidebar} = AuthData();

    const getProjectError = error => {
        setProject({})
        showError(`Error al recuperar el projecto. ${error.message}`)
    }

    useEffect(() => {
        async function loadProject() {
            if(projectId){
                const res = await getProject(projectId,getProjectError)
                setProject(res.data)
                setValue('name', res.data.name)
                setValue('richDescription', res.data.richDescription)
                setValue('deadline', new Date(res.data.deadline))
            }else{
                setValue('deadline', new Date(moment().add(1,'M').add(1,'days')))
            }
        }
  
        loadProject()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(category && category.id && !projectId){
            return(<h1 className='font-bold text-2xl'>{category.name} - Agregar proyecto</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar proyecto</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(category && category.id){
            const payload = {
                name: data.name,
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD'),
                categoryId: category.id
            }
            await createProject(payload, createProjectSuccess, createProjectError)
        }
    })
    const handleUpdate = handleSubmit(async data => {
        if(projectId){
            const payload = {
                name: data.name,
                richDescription: data.richDescription,
                deadline: moment(new Date(data.deadline)).format('YYYY-MM-DD')
            }
    
            await updateProject(projectId, payload, updateProjectSuccess, updateProjectError)
        }
    })

    const createProjectSuccess = (res => {
        showSuccess('Proyecto creado')
        refreshProjectsCategory(category)
        refreshSidebar()
        handleClose()
    })

    const createProjectError = (error => {
        showError(`Error al crear el proyecto. ${error.message}. ${error.response.data}`)
    })

    const updateProjectSuccess = (res => {
        showSuccess('Proyecto actualizado')
        refreshProjectsCategory(category)
        refreshSidebar()
        handleClose()
    })

    const updateProjectError = (error => {
        showError(`Error al actualizar el proyecto. ${error.message}. ${error.response.data}`)
    })

    const handleTemplateChange = (event) => {
        const selectedTemplate = event.target.value
        setValue('richDescription', projectTemplateMarkdown[selectedTemplate] || '', {
            shouldValidate: true,
            shouldDirty: true
        })
    }

    const renderButton = () => {
        if(!projectId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <div className="flex flex-row items-center gap-1">

                        {errors.name && <span className='mb-3 font-bold text-red-500 h-11 flex items-center'>*</span>}
                        <input
                            type="text"
                            placeholder="Nombre"
                            maxLength={50}
                            {...register("name", { required: true, maxLength: 50 })}
                            className=' bg-blue-100 p-3 rounded-lg block w-full mb-3 h-11'
                        />
                        

                        {errors.deadline && <span className='ml-2 mb-3 font-bold text-red-500 h-11 flex items-center'>*</span>}
                        <Controller
                            control={control}
                            name="deadline"
                            rules={{ required: true }}
                            render={({
                                field: { onChange, name, value },
                                fieldState: { invalid, isDirty },
                                formState: { errors },
                            }) => (
                                <>
                                    <DatePicker
                                        value={value || ""}
                                        onChange={(date) => {
                                            onChange(date?.isValid ? date : "");
                                        }}
                                        format={"DD/MM/YYYY"}
                                        inputClass=' bg-blue-100 rounded-lg h-11 pl-3 mb-3'
                                    />
                                </>
                            )}
                        />


                    </div>

                    <div className="flex flex-col">
                        <div className="flex flex-row items-center gap-1">
                            <a className="mb-1" href="https://www.markdownguide.org/cheat-sheet/" target="_blank" rel="noopener noreferrer">Descripción (Markdown, click para guía)</a>
                            <select
                                className='bg-blue-100 rounded-lg h-8 px-2 mb-1 ml-2'
                                onChange={handleTemplateChange}
                                defaultValue=""
                            >
                                {projectTemplateOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                            {errors.richDescription && <span className='ml-2 font-bold text-red-500 h-11 flex items-center'>*</span>}
                        </div>
                        <textarea
                            rows="16"
                            placeholder="Descripción"
                            {...register("richDescription", { required: true })}
                            className='bg-blue-100 p-3 rounded-lg block w-full mb-3'
                        />
                        
                    </div>

                </form>
                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}